import { render, staticRenderFns } from "./input-upload.vue?vue&type=template&id=fc5254e4&scoped=true&"
import script from "./input-upload.vue?vue&type=script&lang=js&"
export * from "./input-upload.vue?vue&type=script&lang=js&"
import style0 from "./input-upload.vue?vue&type=style&index=0&id=fc5254e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc5254e4",
  null
  
)

export default component.exports